import React, { useState, ChangeEvent, FormEvent } from 'react';
import axios from 'axios';
import Breadcrumb from '../components/Breadcrumb';
import { customGPTFileUpload } from '../services/apiService';

const CustomGPT: React.FC = () => {
  const [websiteUrl, setWebsiteUrl] = useState<string>('');
  const [pdfFile, setPdfFile] = useState<File | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');

  const handleUrlChange = (e: ChangeEvent<HTMLInputElement>) => {
    setWebsiteUrl(e.target.value);
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file && file.type === 'application/pdf') {
      setPdfFile(file);
    } else {
      setMessage('Please upload a valid PDF file.');
      setPdfFile(null);
    }
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!websiteUrl || !pdfFile) {
      setMessage('Please enter a website URL and select a PDF file.');
      return;
    }

    const formData = new FormData();
    formData.append('website_url', websiteUrl);
    formData.append('pdf_file', pdfFile);

    try {
      setLoading(true);
      setMessage('');
      const response = await customGPTFileUpload(formData)
      setMessage('Successfully submitted!');
      console.log('Response:', response.data);
    } catch (error) {
      setMessage('Submission failed. Please try again.');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const breadcrumbs = [
        { label: 'Custom GPT Setup', href: '' },
  ];

  return (
    <>
     <Breadcrumb breadcrumbs={breadcrumbs}/>
     <div className="min-h-screen bg-gray-50 py-10 px-4">
      
      <h1 className="text-4xl font-bold text-center text-blue-700 mb-10">Custom GPT Setup</h1>

      <div className="max-w-lg mx-auto bg-white p-6 rounded-2xl shadow-md">
        <h2 className="text-2xl font-semibold mb-4 text-center">Submit Your Website & PDF</h2>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Website URL</label>
            <input
              type="url"
              value={websiteUrl}
              onChange={handleUrlChange}
              placeholder="https://example.com"
              className="w-full px-4 py-2 border rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Upload PDF</label>
            <input
              type="file"
              accept="application/pdf"
              onChange={handleFileChange}
              className="w-full px-4 py-2 border rounded-xl file:mr-4 file:py-2 file:px-4 file:border-0 file:rounded-lg file:bg-blue-100 file:text-blue-700 hover:file:bg-blue-200"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-2 rounded-xl hover:bg-blue-700 transition disabled:opacity-50"
          >
            {loading ? 'Submitting...' : 'Submit'}
          </button>

          {message && (
            <p className={`text-center mt-2 ${message.includes('fail') ? 'text-red-500' : 'text-green-600'}`}>
              {message}
            </p>
          )}
        </form>
      </div>
    </div>
    </>
    
  );
};

export default CustomGPT;
